import { SearchField } from '@/components/SearchField'
import {
  type SideSheetElevation,
  SideSheetHostView,
  SideSheetMain,
} from '@/components/SideSheet'
import {
  StickyViewHeader,
  StickyViewHeaderExtras,
  StickyViewHeaderMain,
  StickyViewHeaderSpacer,
} from '@/components/StickyViewHeader'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { ResultCounts } from '@/components/ResultCounts'
import { type ReactNode } from 'react'
import styles from './Opportunities.module.css'
import { ContentMain, ContentLayout } from '@/components/ContentLayout'

export interface OpportunitiesMainViewProps {
  tabBars?: ReactNode
  sheetVisible: boolean
  sheetElevation: SideSheetElevation
  onRequestHideSheet: () => unknown
  heading: ReactNode
  searchText: string
  onSearchTextChange: (value: string) => unknown
  banner?: ReactNode
  resultCount: number
  list: ReactNode
  detailsSheet?: ReactNode
  overachieverModal: ReactNode
}

export function OpportunitiesMainView({
  tabBars,
  sheetVisible,
  sheetElevation,
  onRequestHideSheet,
  heading,
  searchText,
  onSearchTextChange,
  banner,
  resultCount,
  list,
  detailsSheet,
  overachieverModal,
}: OpportunitiesMainViewProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <>
      <SideSheetHostView
        elevation={sheetElevation}
        sheetVisible={sheetVisible}
        onRequestHide={onRequestHideSheet}
      >
        <SideSheetMain>
          <div className={styles.root} ref={scrollRef}>
            <StickyViewHeader scrollOffset={scrollOffset} tabBar={tabBars}>
              <StickyViewHeaderMain>{heading}</StickyViewHeaderMain>
              <StickyViewHeaderSpacer />
              <StickyViewHeaderExtras>
                <SearchField
                  onChange={onSearchTextChange}
                  value={searchText}
                  testId="opportunity-search-field"
                />
              </StickyViewHeaderExtras>
            </StickyViewHeader>
            <ContentLayout accountForTabBar={Boolean(tabBars)}>
              <ContentMain>
                {banner}

                <div className={styles.resultsCount}>
                  <ResultCounts
                    showing={resultCount}
                    // Don't show total because it will be wrong due to
                    // how Work API filters Ops.
                    total={null}
                  />
                </div>
                {list}
              </ContentMain>
            </ContentLayout>
          </div>
        </SideSheetMain>

        {detailsSheet}
      </SideSheetHostView>
      {overachieverModal}
    </>
  )
}
